import React from "react";
import MainLayout from "../../Layout/mainLayout";

const ListLeads = () => {
  return <MainLayout>Work In Progress</MainLayout>
};

export default ListLeads;
